<template>
	<div
		class="select-input"
		:class="{
			'select-input--disabled': disabled,
			'select-input--focused': focused,
			'select-input--error': error,
			'select-input--empty': !options.length,
			'select-input--no-selection': !value,
		}"
	>
		<div class="select-input__wrapper">
			<FormInput
				:value="computedValue"
				:label="label"
				:label-option="labelOption"
				:placeholder="label"
				readonly
				:error="error"
			/>
			<select
				class="select-input__select"
				ref="input"
				:id="id"
				:name="name"
				:required="required"
				:disabled="disabled || readonly"
				:value="value"
				@change="onInput"
				@focus="onFocus"
				@blur="onBlur"
			>
				<option
					value=""
					disabled
					v-html="label"
				/>
				<option
					v-for="option in options"
					:key="option.value"
					:value="option.value"
					:disabled="option.disabled"
					v-html="option.label || option.value"
				/>
			</select>
		</div>
		<span
			class="form-input__hint | form-input-hint"
			v-if="hint"
			v-html="hint"
		/>
		<span
			class="form-input__error | form-input-error"
			v-if="error && errorMessage"
			v-html="errorMessage"
		/>
		<span
			class="form-input__success | form-input-success"
			v-if="successMessage"
			v-html="successMessage"
		/>
	</div>
</template>

<script>
import FormInput from './FormInput';

export default {
	components: {
		FormInput,
	},
	props: {
		id: String,
		name: String,
		value: Number | String,
		required: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		label: String,
		labelOption: String,
		options: Array,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	data() {
		return {
			focused: false,
		}
	},
	computed: {
		computedValue() {
			const option = this.options.filter(option => option.value == this.value)[0];
			return option ? option.label || option.value : '';
		}
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	methods: {
		onInput(e) {
			this.$emit('input', e.target.value);
		},
		onFocus(e) {
			this.focused = true;
			this.$emit('focus', e);
		},
		onBlur(e) {
			this.focused = false;
			this.$emit('blur', e);
		},
	}
}
</script>

<style>

</style>
